import { usePragmaticDGA } from '../../composables/usePragmaticDGA'
import type { GameLimits } from '../../types'

interface UseGameCardLimitsReturn {
  isGameHasLimits: Ref<boolean>
  limits: ComputedRef<GameLimits | undefined>
  playersLimits: ComputedRef<string>
  currencyLimit: ComputedRef<string>
}

export function useGameCardLimits(
  gameId: MaybeRefOrGetter<number | undefined>,
): UseGameCardLimitsReturn {
  const { isGameHasLimits, limits } = usePragmaticDGA(() => toValue(gameId))

  const { format } = useNumberFormatter()
  const { format: formatCurrency } = useCurrencyFormatter({ currency: 'USD' })

  const playersLimits = computed(() => {
    if (!limits.value) return ''

    const { totalSeatedPlayers, maxPlayers } = limits.value

    if (totalSeatedPlayers && maxPlayers) {
      return `${format(totalSeatedPlayers)}/${format(maxPlayers)}`
    }

    if (totalSeatedPlayers) {
      return format(totalSeatedPlayers)
    }

    if (maxPlayers) {
      return format(maxPlayers)
    }

    return ''
  })

  const currencyLimit = computed(() => {
    if (!limits.value) return ''

    const { minBet, maxBet } = limits.value

    if (minBet && maxBet) {
      return `${formatCurrency(minBet)} - ${formatCurrency(maxBet)}`
    }

    if (minBet) {
      return formatCurrency(minBet)
    }

    if (maxBet) {
      return formatCurrency(maxBet)
    }

    return ''
  })

  return {
    isGameHasLimits,
    playersLimits,
    currencyLimit,
    limits,
  }
}
